import React, { forwardRef, useRef } from "react";
import PropTypes from "prop-types";
import DraggableList from "react-draggable-list";

const DraggableButtons = (props) => {
  const containerRef = useRef(null);

  return (
    <div style={{ overflow: "hidden", paddingBottom: "10px" }}>
      {props.children}
      <DraggableList
        itemKey="name"
        template={DraggableButton}
        list={props.list}
        commonProps={props}
        onMoveEnd={props.onListChange}
        container={() => containerRef.current}
      />
    </div>
  );
};

const DraggableButton = forwardRef((props, ref) => {
  const { item, commonProps, dragHandleProps, itemSelected } = props;
  const myIndex = commonProps.list.findIndex((li) => li === item);

  const toggleModule = () => {
    const module = document.getElementById(
      item.name.replace(/\s/g, "").toLowerCase() + "ModuleWrapper"
    );
    const buttonElement = document.getElementById(item.name + "Button");
    const display = module.classList.contains("active");

    const activeModules = commonProps.list.filter((pref) => pref.active);
    if (display && activeModules.length === 1) {
      return;
    }

    const filteredArray = commonProps.list.map((pref) => {
      if (pref.name === item.name) {
        return {
          ...pref,
          active: !display
        };
      }
      return pref;
    });

    if (!display) {
      module.classList.add("active");
      buttonElement.classList.remove("inActive");
    } else {
      module.classList.remove("active");
      buttonElement.classList.add("inActive");
    }

    commonProps.onButtonChange(filteredArray);
  };

  return (
    <div
      ref={ref}
      id={item.name + "Button"}
      className={`draggable-button ${item.active ? "" : "inActive"}`}
      style={{ transform: `rotate(${itemSelected * 3}deg)` }}
      data-testid="button-container"
    >
      <div className="draggable-button__inner" {...dragHandleProps}>
        <span className="order-number" onClick={toggleModule} data-testid="order-number">
          <span className="number">{myIndex + 1}</span>
        </span>
        <span className="title" data-testid="title">
          {item.displayName}
        </span>
      </div>
    </div>
  );
});

export default DraggableButtons;

DraggableButtons.propTypes = {
  onListChange: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.any]),
  list: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number
    })
  )
};

DraggableButton.propTypes = {
  commonProps: PropTypes.shape({
    list: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        displayName: PropTypes.string,
        id: PropTypes.number
      })
    )
  }),
  item: PropTypes.shape({
    name: PropTypes.string,
    displayName: PropTypes.string,
    id: PropTypes.number
  }),
  itemSelected: PropTypes.number,
  dragHandleProps: PropTypes.object,
  onMouseDown: PropTypes.func
};
DraggableButton.displayName = "DraggableButton";
